import { render, staticRenderFns } from "./TableDeliveryOrderPreview.vue?vue&type=template&id=1c95119a&scoped=true&"
import script from "./TableDeliveryOrderPreview.vue?vue&type=script&lang=js&"
export * from "./TableDeliveryOrderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95119a",
  null
  
)

export default component.exports